import { Button, Form, Input, message, Select, Upload } from "antd";
import FormItem from "antd/es/form/FormItem";
import PropTypes from "prop-types";
import { useEffect } from "react";
import useToast from "../../../hooks/userToast";
import { Option } from "antd/es/mentions";
import { UploadOutlined } from "@ant-design/icons";
import apiClient from "../../../utils/apiClient";

AddTemplateTable.propTypes = {
  fetchData: PropTypes.func,
  handleOk: PropTypes.func,
  type: PropTypes.string,
};

const props = {
  name: "file",
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  beforeUpload: (file) => {
    const isDocOrDocx =
      file.type === "application/msword" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

    if (!isDocOrDocx) {
      message.error("You can only upload .doc or .docx files!");
      return Upload.LIST_IGNORE;
    }
    return false;
  },
  headers: {
    authorization: "authorization-text",
  },
  accept: ".doc,.docx",
};

function AddTemplateTable({ fetchData, handleOk }) {
  const [form] = Form.useForm();

  const { toastError, toastSuccess } = useToast();

  const handlePost = async (values) => {
    try {
      const formData = new FormData();
      formData.append("name", values?.name);
      formData.append("modality", values?.modality);
      formData.append("template-pdf", values?.template.file);

      await apiClient.post("template/create", formData);
      toastSuccess("Added Successfully!");
      fetchData();
      handleOk();
      form.resetFields();
    } catch (error) {
      console.log("error====>", error);
      toastError(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    form.resetFields();
    console.log("reset fields works");
  }, []);

  return (
    <>
      <Form onFinish={handlePost} form={form}>
        <FormItem
          name="name"
          label="Name"
          rules={[{ required: true, message: "Name Required" }]}
        >
          <Input />
        </FormItem>

        <FormItem
          name="modality"
          label="Modality"
          rules={[{ required: true, message: "Modality Required" }]}
        >
          <Select placeholder="Select Modality">
            <Option value="CT">CT</Option>
            <Option value="MRI">MRI</Option>
            <Option value="X-RAY">X-RAY</Option>
          </Select>
        </FormItem>
        <FormItem
          name="template"
          label="Template File"
          rules={[{ required: true, message: "File Required" }]}
          labelAlign="right"
        >
          <Upload {...props} maxCount={1}>
            <Button icon={<UploadOutlined />}>Select File</Button>
          </Upload>
        </FormItem>

        <div
          className="add_templatebutton"
          style={{ display: "flex", justifyContent: " center" }}
        >
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </div>
      </Form>
    </>
  );
}

export default AddTemplateTable;
